import { render } from "./YTable.vue?vue&type=template&id=6e079a46&scoped=true"
import script from "./YTable.vue?vue&type=script&lang=js"
export * from "./YTable.vue?vue&type=script&lang=js"

import "./YTable.vue?vue&type=style&index=0&id=6e079a46&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/线上短信平台/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e079a46"]])

export default __exports__